export default __webpack_public_path__ + "static/media/oscer-back-pain.081da6fb.svg";